export default "__VITE_ASSET__6a4de058__"